<template>
  <div class="newJournal-view">
    <div class="section-header">
      <h1>
        {{ $t("journal") }}
      </h1>
      <ul class="conventions ml-auto">
        <li v-for="(con, index) in conventions" :key="index" :class="con.class">
          <v-icon class="icon" x-small icon>fa-circle</v-icon>{{ con.name }}
        </li>
      </ul>
    </div>
    <!--Button mobile-->
    <v-btn v-if="isMobile" @click="showFilters = !showFilters" class="primary-btn centered-button">
      {{ showFilters ? $t("closefilters") : $t("openfilters") }}
    </v-btn>
    <!--desktop-->
    <div v-show="showFilters || !isMobile"
      class="section-filters sticky-section col-lg-12 col-md-12 col-sm-12 col-xs-12 d-sm-flex justify-content-sm-end">
      <div class="old-filters">
        <OverallFilters ref="filters"></OverallFilters>
      </div>
      <div
        class="filters col-lg-10 col-md-12 col-sm-12 col-xs-12 pa-0 d-sm-flex justify-space-between justify-content-sm-end">
        <SwisetSelect :class="filter.ref + ' col-lg-1 col-md-3 col-sm-4 col-xs-4'" v-for="(filter, index) in filters"
          :ref="filter.ref" :key="index" :label="filter.label" :options="filter.options" :type="filter.type"
          :selectedValue="filter.selectedValue" :allOption="filter.allOption" :placeholder="filter.placeholder"
          :changeEvent="filter.changeEvent ? filter.changeEvent : undefined"></SwisetSelect>
      </div>
      <v-overlay @click="(e) => closeOverlay(e)" :dark="false" v-model="overlayDates">
        <div class="datesContainer">
          <v-text-field class="v-text-field" v-model="dateRangeText"
            :label="this.$i18n.messages[this.$i18n.locale].selectedPeriod" readonly disabled></v-text-field>
          <v-date-picker class="v-date-picker" v-model="dates" range></v-date-picker>
          <v-btn @click="confirmCustomDates()" :disabled="checkDates">
            Confirm
          </v-btn>
        </div>
      </v-overlay>
      <div class="actions col-lg-2 col-md-12 col-sm-12 col-xs-12 mx-auto pa-0">
        <v-btn @click="() => updateFilters()" class="primary-btn">
          <v-icon small class="mr-2">fa-regular fa-filter</v-icon>{{ $t("apply") }}
        </v-btn>
        <v-btn @click="resetFields()" color="secondary" class="secondary-btn"><v-icon small>
            fa-regular fa-undo
          </v-icon>
        </v-btn>
      </div>
    </div>
    <div>
      <div class="section-ratios mt-10">
        <h2>{{ $t("highlight") }}</h2>
        <div class="ratios-container">
          <v-col v-for="(ratio, index) in ratios" :key="'ratio-col-' + index" lg="2" md="3" sm="4" cols="6"
            :class="'desktop ' + (index == 0 || index == 5 ? 'pl-0 ' : ' ') + (index == 4 || index == 9 ? 'pr-0' : '')">
            <RatioCard :key="index" :chip="ratio.chip" :mainText="ratio.mainText" :subText="ratio.subText"
              :appColor="ratio.appColor"></RatioCard>
          </v-col>

          <!-- En pantallas pequeñas, muestra las tarjetas en un carrusel -->
          <div class="carousel-container mobile col-12 d-flex justify-content-center d-none d-sm-block">
            <v-carousel show-arrows hide-delimiters height="13vh" cycle>
              <v-carousel-item v-for="(ratio, index) in ratios" :key="'ratio-col-' + index">
                <RatioCard :key="index" :chip="ratio.chip" :mainText="ratio.mainText" :subText="ratio.subText"
                  :appColor="ratio.appColor" class="ratio-card ratio-card-mobile"></RatioCard>
              </v-carousel-item>
            </v-carousel>
          </div>
        </div>
      </div>
      <div>
        <div class="section-tabs  mt-12">
          <h2>{{ $t("detailed") }}</h2>
          <Tabs class="mt-3" :newTrades="newTrades" :tabs="tabs" />
        </div>
      </div>
      <v-overlay :value="overlay" :dark="false">
        <AddTrade @closeOverlay="overlay = false" @tradesLimitReached="tradesLimitReached" @newTrade="newTrade" />
      </v-overlay>
      <v-overlay :value="overlayJournalModes" :dark="false">
        <JournalModes @importAdding="importAdding" @manuallyAdding="manuallyAdding"
          @closeWindow="overlayJournalModes = false" />
      </v-overlay>
      <v-overlay v-model="overlayUpgradeToPro" :dark="false">
        <UpgradeToPro :message="messageUpgradeToPro" @closeWindow="closeOverlayUpgradeToPro" />
      </v-overlay>
      <v-overlay :dark="false" :value="overlayImportTrades">
        <ImportTrades @closeImport="overlayImportTrades = false" />
      </v-overlay>
    </div>
  </div>
</template>
<script>
import Moods from "../moods";
import RatioCard from "../components/RatioCard.vue";
import Tabs from "../../../components/Tabs.vue";
import SwisetSelect from "../../../components/comp-base/SwisetSelect.vue";
import OverallFilters from "../components/OverallFilters.vue";
import Repository from "../../../repositories/journal";
import AddTrade from "../AddTrade.vue";
import JournalModes from "../components/JournalModes.vue";
import UpgradeToPro from "../../../components/UpgradeToPro.vue";
import ImportTrades from "../components/ImportTrades.vue";
import BrokerAccountRepository from "../../../repositories/brokerAccount";
import { mapMutations } from "vuex";

export default {
  name: "NewJournal",
  components: {
    RatioCard,
    Tabs,
    OverallFilters,
    JournalModes,
    AddTrade,
    UpgradeToPro,
    ImportTrades,
    SwisetSelect,
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.isMobile = window.innerWidth <= 768;
    });
    /* eslint-disable no-console */
    this.trades = this.$store.state.book.trades;
    this.$refs.Month[0].selectedValue =
      this.$i18n.messages[this.$i18n.locale].week;
    this.updateFilters();
    let accSelect = this.$refs.Accounts[0].$el;
    const store = this.$store;
    accSelect.querySelectorAll(".option").forEach(function (el, index) {
      if (index > 1) {
        let identifier = el.textContent.split("~")[0];
        let isVerified = store.state.user.brokerAccounts.find(
          (b) => b.identifier.trim() === identifier.trim()
        ).verified;
        if (isVerified) {
          let icon = document.createElement("img");
          icon.src = require("@/assets/icons/Audited.svg");
          icon.alt = "Audited Icon";
          icon.style.position = "absolute";
          icon.style.width = "16px";
          icon.style.height = "16px";
          icon.style.right = 0;
          el.appendChild(icon);
        }
      }
    });
    this.init();
  },
  computed: {
    dateRangeText() {
      return this.dates.join(" ~ ");
    },
    checkDates() {
      return !(this.dates.length == 2);
    },
  },
  methods: {
    ...mapMutations(["setTradesPageable", "setBrokerAccounts"]),
    async init(){
      await BrokerAccountRepository.allBrokerAccountsOfUser().then((response) => {
        this.setBrokerAccounts(response.data);
      });
    },
    updateFilters() {
      let tempDate = new Date(this.fromDate);
      let fullFromDate = new Date(
        tempDate.getFullYear(),
        tempDate.getMonth(),
        tempDate.getDate(),
        0,
        0
      );
      var month;
      if (this.$refs.Month[0].selectedValue)
        month = this.$refs.Month[0].selectedValue.trim();
      switch (month) {
        case this.$i18n.messages[this.$i18n.locale].week:
          fullFromDate.setDate(fullFromDate.getDate() - 7);
          break;
        case this.$i18n.messages[this.$i18n.locale].month:
          fullFromDate.setDate(fullFromDate.getDate() - 30);
          break;
        case this.$i18n.messages[this.$i18n.locale]["60days"]:
          fullFromDate.setDate(fullFromDate.getDate() - 60);
          break;
        case this.$i18n.messages[this.$i18n.locale]["90days"]:
          fullFromDate.setDate(fullFromDate.getDate() - 90);
          break;
        default:
          fullFromDate = this.fullFromDateP;
          break;
      }
      let fullToDate = this.fullToDateP;
      if (!fullToDate)
        fullToDate = new Date(
          this.toDate.getFullYear(),
          this.toDate.getMonth(),
          this.toDate.getDate(),
          0,
          0
        );
      fullToDate.setDate(fullToDate.getDate() + 1);
      let moodsKey = Moods.map((m) => m.key);
      if (this.$refs.Moods[0].selectedValue) {
        if (
          this.$refs.Moods[0].selectedValue !==
          this.$i18n.messages[this.$i18n.locale].all
        ) {
          moodsKey = [];
          for (let i = 0; i < this.$refs.Moods[0].selectedValue.length; i++) {
            moodsKey[i] = Moods.filter(
              (mood) =>
                mood[this.$i18n.locale] === this.$refs.Moods[0].selectedValue[i]
            )[0].key;
          }
        }
      }
      this.showFilters = !this.showFilters;
      this.$refs.filters.setFilterMade(true);
      this.$refs.filters.setCurrentFilter({
        allStrategies: this.$refs.Strategies[0].selectedValue ? false : true,
        fromDate: fullFromDate,
        toDate: fullToDate,
        side: this.$refs.Sides[0].selectedValue
          ? this.$refs.Sides[0].selectedValue.trim().toUpperCase()
          : "All",
        mood: moodsKey,
        asset: this.$refs.Assets[0].selectedValue
          ? this.$refs.Assets[0].selectedValue.map((val) => {
            return this.$store.state.user.assets.filter(
              (asset) => val == asset.assetName
            )[0].ticker;
          })
          : this.$store.state.user.assets.map((asset) => asset.ticker),
        brokerAccount: this.$refs.Accounts[0].selectedValue
          ? this.$refs.Accounts[0].selectedValue.map((val) => {
            return this.$store.state.user.brokerAccounts.filter(
              (acc) => acc.identifier == val.split(" ")[0]
            )[0].id;
          })
          : this.$store.state.user.brokerAccounts.map((acc) => acc.id),
        result: this.$refs.Results[0].selectedValue
          ? this.$refs.Results[0].selectedValue
          : "All",
        strategy: this.$refs.Strategies[0].selectedValue
          ? this.$refs.Strategies[0].selectedValue.map((val) => {
            return this.$store.state.user.strategies.filter(
              (s) => s.name == val
            )[0].id;
          })
          : ["-1"],
      });
      if (this.$route.name == "stats") {
        this.setTradesPageable(null);
      }
      this.$refs.filters.callFilter({
        allStrategies: this.$refs.Strategies[0].selectedValue ? false : true,
        fromDate: fullFromDate,
        toDate: fullToDate,
        side: this.$refs.Sides[0].selectedValue
          ? this.$refs.Sides[0].selectedValue.trim().toUpperCase()
          : "All",
        mood: moodsKey,
        asset: this.$refs.Assets[0].selectedValue
          ? this.$refs.Assets[0].selectedValue.map((val) => {
            return this.$store.state.user.assets.filter(
              (asset) => val == asset.assetName
            )[0].ticker;
          })
          : this.$store.state.user.assets.map((asset) => asset.ticker),
        brokerAccount: this.$refs.Accounts[0].selectedValue
          ? this.$refs.Accounts[0].selectedValue.map((val) => {
            return this.$store.state.user.brokerAccounts.filter(
              (acc) => acc.identifier == val.split(" ")[0]
            )[0].id;
          })
          : this.$store.state.user.brokerAccounts.map((acc) => acc.id),
        result: this.$refs.Results[0].selectedValue
          ? this.$refs.Results[0].selectedValue
          : "All",
        strategy: this.$refs.Strategies[0].selectedValue
          ? this.$refs.Strategies[0].selectedValue.map((val) => {
            return this.$store.state.user.strategies.filter(
              (s) => s.name == val
            )[0].id;
          })
          : ["-1"],
      });

      Repository.analyticsSummary({
        allStrategies: this.$refs.Strategies[0].selectedValue ? false : true,
        fromDate: fullFromDate,
        toDate: fullToDate,
        side: this.$refs.Sides[0].selectedValue
          ? this.$refs.Sides[0].selectedValue.trim().toUpperCase()
          : "All",
        moods: moodsKey,
        assets: this.$refs.Assets[0].selectedValue
          ? this.$refs.Assets[0].selectedValue.map((val) => {
            return this.$store.state.user.assets.filter(
              (asset) => val == asset.assetName
            )[0].ticker;
          })
          : this.$store.state.user.assets.map((asset) => asset.ticker),
        brokerAccounts: this.$refs.Accounts[0].selectedValue
          ? this.$refs.Accounts[0].selectedValue.map((val) => {
            return this.$store.state.user.brokerAccounts.filter(
              (acc) => acc.identifier == val.split(" ")[0]
            )[0].id;
          })
          : this.$store.state.user.brokerAccounts.map((acc) => acc.id),
        result: this.$refs.Results[0].selectedValue
          ? this.$refs.Results[0].selectedValue
          : "All",
        strategies: this.$refs.Strategies[0].selectedValue
          ? this.$refs.Strategies[0].selectedValue.map((val) => {
            return this.$store.state.user.strategies.filter(
              (s) => s.name == val
            )[0].id;
          })
          : ["-1"],
      }).then((response) => {
        if (response.status < 400) {
          let analytics = response.data.content[0];
          let duration = new Date(analytics.averageDuration * 1000)
            .toISOString()
            .substring(11, 19)
            .split(":");
          this.ratios = [
            {
              chip: analytics.netProfit >= 0 ? "Profitable" : "",
              mainText:
                (analytics.netProfit >= 0 ? "+$" : "$") +
                analytics.netProfit.toFixed(2).toString(),
              subText: "Net Profit",
              appColor: analytics.netProfit >= 0 ? "success" : "error",
              tooltip: { text: "Esto es un tootilp de prueba" },
            },
            {
              chip: undefined,
              mainText: analytics.swisetRatio.toFixed(2),
              subText: "Swiset Ratio",
              appColor: analytics.swisetRatio >= 1 ? "success" : "error",
            },
            {
              chip: undefined,
              mainText: (analytics.winRate * 100).toFixed(2) + "%",
              subText: "Win Rate",
              appColor: "black",
            },
            {
              chip: undefined,
              mainText: "1:" + analytics.riskReward.toFixed(2).toString(),
              subText: "Risk/Reward Ratio",
              appColor: "black",
            },
            {
              chip: undefined,
              mainText: analytics.profitFactor.toFixed(2).toString(),
              subText: "Profit Factor",
              appColor: analytics.profitFactor >= 1 ? "success" : "error",
            },
            {
              chip: undefined,
              mainText:
                (analytics.profitBestTrade >= 0 ? "+$" : "$") +
                analytics.profitBestTrade.toString(),
              subText: "Best Trade",
              appColor: "success",
            },
            {
              chip: undefined,
              mainText: "$" + analytics.profitWorstTrade.toString(),
              subText: "Worst Trade",
              appColor: "error",
            },
            {
              chip: undefined,
              mainText: analytics.trades.toString(),
              subText: "Total Trades",
              appColor: "black",
            },
            {
              chip: undefined,
              mainText:
                duration[0] + "h " + duration[1] + "m " + duration[2] + "s",
              subText: "Avg. Duration",
              appColor: "black",
            },
            {
              chip: undefined,
              mainText: "$" + analytics.commissions.toFixed(2).toString(),
              subText: "Total Commissions",
              appColor: "black",
            },
          ];
        }
      });
      this.$router.replace({
        query: {
          startDate: fullFromDate.toISOString().split("T")[0],
          endDate: fullToDate.toISOString().split("T")[0],
        },
      });
    },
    openDateModal() {
      let month = this.$refs.Month[0].selectedValue;
      switch (month) {
        case this.$i18n.messages[this.$i18n.locale].week:
          break;
        case this.$i18n.messages[this.$i18n.locale].month:
          break;
        case this.$i18n.messages[this.$i18n.locale]["60days"]:
          break;
        case this.$i18n.messages[this.$i18n.locale]["90days"]:
          break;
        default:
          this.overlayDates = true;
          break;
      }
    },
    resetFields() {
      this.$refs.Month[0].selectedValue = undefined;
      this.$refs.Sides[0].selectedValue = undefined;
      this.$refs.Assets[0].selectedValue = undefined;
      this.$refs.Accounts[0].selectedValue = undefined;
      this.$refs.Results[0].selectedValue = undefined;
      this.$refs.Strategies[0].selectedValue = undefined;
      this.$refs.Moods[0].selectedValue = undefined;
      this.toDate = new Date();
      this.fromDate = new Date(this.toDate).setDate(this.toDate.getDate() - 7);
      this.fullFromDateP = new Date(this.fromDate);
      this.fullToDateP = new Date(this.toDate);
      this.updateFilters();
    },
    closeOverlay(e) {
      if (e.target.classList.contains("v-overlay__scrim")) {
        this.overlayDates = false;
      }
    },
    confirmCustomDates() {
      let fullFromDate = new Date(this.dates[0]);
      let fullToDate = new Date(this.dates[1]);
      let fullFromDateP = new Date(
        fullFromDate.getFullYear(),
        fullFromDate.getMonth(),
        fullFromDate.getDate(),
        0,
        0
      );
      let fullToDateP = new Date(
        fullToDate.getFullYear(),
        fullToDate.getMonth(),
        fullToDate.getDate(),
        0,
        0
      );
      fullToDate.setDate();
      this.fullFromDateP = fullFromDateP;
      this.fullToDateP = fullToDateP;
      this.overlayDates = false;
    },
    manuallyAdding() {
      this.overlayJournalModes = false;
      this.overlay = true;
    },
    importAdding() {
      if (this.$store.state.user.isPro) this.overlayJournalModes = false;
      this.importTradesOverlay();
    },
    importTradesOverlay() {
      if (!this.$store.state.user.isPro) {
        this.overlayUpgradeToPro = true;
        this.messageUpgradeToPro =
          "You cannot import trades. With Pro you can import historic trades from several platforms.";
      } else this.overlayImportTrades = true;
    },
    closeOverlayUpgradeToPro() {
      this.overlayUpgradeToPro = false;
    },
    newTrade() {
      this.overlay = false;
    },
    tradesLimitReached() {
      this.messageUpgradeToPro =
        "You reached the limit of trades for the month of this trade. With pro you can register unlimited trades.";
      this.overlayUpgradeToPro = true;
      this.overlay = false;
    },
    newTrades() {
      this.overlayJournalModes = true
    },
  },
  data() {
    return {
      fromDate: new Date(),
      toDate: new Date(),
      trades: [],
      dates: [],
      overlayDates: false,
      overlay: false,
      overlayJournalModes: false,
      overlayUpgradeToPro: false,
      fullFromDateP: undefined,
      messageUpgradeToPro: "",
      overlayImportTrades: false,
      fullToDateP: undefined,
      showFilters: false,
      isMobile: window.innerWidth <= 768,
      conventions: [
        { name: this.$i18n.messages[this.$i18n.locale].profit, class: "green" },
        { name: this.$i18n.messages[this.$i18n.locale].loss, class: "red" },
        { name: this.$i18n.messages[this.$i18n.locale].normal, class: "black" },
      ],
      filters: [
        {
          ref: "Month",
          placeholder: this.$i18n.messages[this.$i18n.locale].time,
          label: this.$i18n.messages[this.$i18n.locale].time,
          options: [
            this.$i18n.messages[this.$i18n.locale].week,
            this.$i18n.messages[this.$i18n.locale].month,
            this.$i18n.messages[this.$i18n.locale]["60days"],
            this.$i18n.messages[this.$i18n.locale]["90days"],
            this.$i18n.messages[this.$i18n.locale]["customPeriod"],
          ],
          type: 0,
          selectedValue: undefined,
          allOption: false,
          changeEvent: this.openDateModal,
        },
        {
          ref: "Accounts",
          placeholder: this.$i18n.messages[this.$i18n.locale].accounts,
          label: this.$i18n.messages[this.$i18n.locale].accounts,
          options: this.$store.state.user.brokerAccounts.map(
            (acc) =>
              acc.identifier + " ~ " + acc.broker.name.substring(0, 10) + "..."
          ),
          type: 1,
          selectedValue: undefined,
          allOption: true,
        },
        {
          ref: "Assets",
          placeholder: this.$i18n.messages[this.$i18n.locale].assets,
          label: this.$i18n.messages[this.$i18n.locale].assets,
          options: this.$store.state.user.assets.map(
            (asset) => asset.assetName
          ),
          type: 1,
          selectedValue: undefined,
          allOption: true,
        },
        {
          ref: "Sides",
          placeholder: this.$i18n.messages[this.$i18n.locale].sides,
          label: this.$i18n.messages[this.$i18n.locale].sides,
          options: this.$store.state.sides,
          type: 0,
          selectedValue: undefined,
          allOption: true,
        },
        {
          ref: "Results",
          placeholder: this.$i18n.messages[this.$i18n.locale].results,
          label: this.$i18n.messages[this.$i18n.locale].results,
          options: this.$store.state.results,
          type: 0,
          selectedValue: undefined,
          allOption: true,
        },
        {
          ref: "Moods",
          placeholder: this.$i18n.messages[this.$i18n.locale].moods,
          label: this.$i18n.messages[this.$i18n.locale].moods,
          options: Moods.map((m) => m[this.$i18n.locale]),
          type: 1,
          selectedValue: undefined,
          allOption: true,
        },
        {
          ref: "Strategies",
          placeholder: this.$i18n.messages[this.$i18n.locale].strategies,
          label: this.$i18n.messages[this.$i18n.locale].strategies,
          options: this.$store.state.user.strategies.map((s) => s.name),
          type: 1,
          selectedValue: undefined,
          allOption: true,
        },
      ],
      ratios: [],
      tabs: [
        {
          name: this.$i18n.messages[this.$i18n.locale].trades,
          base: "journal",
          path: "data",
          icon: "fa-list",
        },
        {
          name: this.$i18n.messages[this.$i18n.locale].statics,
          base: "journal",
          path: "stats",
          icon: "fa-chart-simple",
        },
        {
          name: this.$i18n.messages[this.$i18n.locale].calendar,
          base: "journal",
          path: "calendar",
          icon: "fa-calendar",
        },
      ],
    };
  },
};
</script>
<i18n>
    {
      "en": {
        "week": "This week",
        "month": "Last 30 days",
        "90days": "Last 90 days",
        "60days":"Last 60 days",
        "customPeriod":"Custom period",        "time":"Date",
        "strategies": "Strategies",
        "moods":"Moods",
        "assets":"Assets",
        "results":"Results",
        "accounts":"Accounts",
        "sides":"Side",
        "apply":"Apply",
        "selectedPeriod":"Selected period",
        "profit":"Profit",
        "loss":"Loss",
        "normal":"Neutral",
        "highlight":"Your Highlights",
        "detailed":"Detailed Data",
        "journal":"Trading Journal",
        "trades":"Trades",
        "statics":"Stats",
        "calendar":"Calendar",
        "all":"All",
        "closefilters": "Close filters",
        "openfilters": "Open filters",
        "addBrokerAccount": "Add broker account",
        "reset": "Reset",
        "netProfit": "Net Profit",
        "swisetRatio": "Swiset Ratio",
        "winRate": "Win Rate",
        "profitFactor": "Profit Factor",
        "bestTrade": "Best Trade",
        "worstTrade": "Worst Trade",
        "averageDuration": "Average Duration",
        "commissions": "Commissions",
        "riskReward": "Risk/Reward Ratio",
        "profitable": "Profitable"
      },
      "es": {
        "week": "Última semana",
        "month": "Últimos 30 dias",
        "90days": "Últimos 90 dias",
        "60days":"Últimos 60 dias",
        "customPeriod":"Periodo personalizado",        "time":"Fecha",
        "strategies": "Estrategias",
        "moods":"Sentimientos",
        "assets":"Activos",
        "results":"Resultado",
        "accounts":"Cuentas",
        "sides":"Lado",
        "apply":"Filtrar",
        "selectedPeriod":"Periodo seleccionado",
        "profit":"Rentable",
        "loss":"Pérdida",
        "normal":"Neutral",
        "highlight":"Información Destacada",
        "detailed":"Información Detallada",
        "journal":"Bitácora de Trading",
        "trades":"Trades",
        "statics":"Estadísticas",
        "calendar":"Calendario",
        "all":"Todo",
        "closefilters": "Cerrar filtros",
        "openfilters": "Abrir filtros",
        "addBrokerAccount": "Añadir Cuenta de Broker",
        "reset": "Reiniciar",
        "netProfit": "Ganancia Neta",
        "swisetRatio": "Ratio Swiset",
        "winRate": "Tasa de Éxito",
        "profitFactor": "Factor de Ganancia",
        "bestTrade": "Mejor Trade",
        "worstTrade": "Peor Trade",
        "averageDuration": "Duración Promedio",
        "commissions": "Comisiones",
        "riskReward": "Ratio Riesgo/Recompensa",
        "profitable": "Rentable"
      },
      "ko": {
        "week": "이번 주",
        "month": "지난 30일",
        "90days": "지난 90일",
        "60days": "지난 60일",
        "customPeriod": "사용자 지정 기간",        "time": "날짜",
        "strategies": "전략",
        "moods": "감정",
        "assets": "자산",
        "results": "결과",
        "accounts": "계좌",
        "sides": "방향",
        "apply": "적용",
        "selectedPeriod": "선택한 기간",
        "profit": "수익",
        "loss": "손실",
        "normal": "중립",
        "highlight": "주요 사항",
        "detailed": "상세 데이터",
        "journal": "트레이딩 저널",
        "trades": "거래",
        "statics": "통계",
        "calendar": "달력",
        "all": "전체",
        "closefilters": "필터 닫기",
        "openfilters": "필터 열기",
        "addBrokerAccount": "브로커 계좌 추가",
        "reset": "재설정",
        "netProfit": "순이익",
        "swisetRatio": "Swiset 비율",
        "winRate": "승률",
        "profitFactor": "수익 계수",
        "bestTrade": "최고 거래",
        "worstTrade": "최악의 거래",
        "averageDuration": "평균 지속 시간",
        "commissions": "수수료",
        "riskReward": "위험/보상 비율",
        "profitable": "수익성 있음"
      },
      "pt": {
        "week": "Esta semana",
        "month": "Últimos 30 dias",
        "90days": "Últimos 90 dias",
        "60days": "Últimos 60 dias",
        "customPeriod": "Período personalizado",        "time": "Data",
        "strategies": "Estratégias",
        "moods": "Humores",
        "assets": "Ativos",
        "results": "Resultados",
        "accounts": "Contas",
        "sides": "Lado",
        "apply": "Aplicar",
        "selectedPeriod": "Período selecionado",
        "profit": "Lucro",
        "loss": "Perda",
        "normal": "Neutro",
        "highlight": "Seus Destaques",
        "detailed": "Dados Detalhados",
        "journal": "Diário de Trading",
        "trades": "Negociações",
        "statics": "Estatísticas",
        "calendar": "Calendário",
        "all": "Todos",
        "closefilters": "Fechar filtros",
        "openfilters": "Abrir filtros",
        "addBrokerAccount": "Adicionar conta de corretora",
        "reset": "Redefinir",
        "netProfit": "Lucro Líquido",
        "swisetRatio": "Índice Swiset",
        "winRate": "Taxa de Sucesso",
        "profitFactor": "Fator de Lucro",
        "bestTrade": "Melhor Negociação",
        "worstTrade": "Pior Negociação",
        "averageDuration": "Duração Média",
        "commissions": "Comissões",
        "riskReward": "Razão Risco/Recompensa",
        "profitable": "Lucrativo"
      },
      "th": {
        "week": "สัปดาห์นี้",
        "month": "30 วันที่ผ่านมา",
        "90days": "90 วันที่ผ่านมา",
        "60days": "60 วันที่ผ่านมา",
        "customPeriod": "ช่วงเวลาที่กำหนดเอง",        "time": "วันที่",
        "strategies": "กลยุทธ์",
        "moods": "อารมณ์",
        "assets": "สินทรัพย์",
        "results": "ผลลัพธ์",
        "accounts": "บัญชี",
        "sides": "ด้าน",
        "apply": "นำไปใช้",
        "selectedPeriod": "ช่วงเวลาที่เลือก",
        "profit": "กำไร",
        "loss": "ขาดทุน",
        "normal": "ปกติ",
        "highlight": "ไฮไลท์ของคุณ",
        "detailed": "ข้อมูลรายละเอียด",
        "journal": "บันทึกการเทรด",
        "trades": "การเทรด",
        "statics": "สถิติ",
        "calendar": "ปฏิทิน",
        "all": "ทั้งหมด",
        "closefilters": "ปิดตัวกรอง",
        "openfilters": "เปิดตัวกรอง",
        "addBrokerAccount": "เพิ่มบัญชีโบรกเกอร์",
        "reset": "รีเซ็ต",
        "netProfit": "กำไรสุทธิ",
        "swisetRatio": "อัตราส่วน Swiset",
        "winRate": "อัตราการชนะ",
        "profitFactor": "ปัจจัยกำไร",
        "bestTrade": "การเทรดที่ดีที่สุด",
        "worstTrade": "การเทรดที่แย่ที่สุด",
        "averageDuration": "ระยะเวลาเฉลี่ย",
        "commissions": "ค่าคอมมิชชั่น",
        "riskReward": "อัตราส่วนความเสี่ยง/ผลตอบแทน",
        "profitable": "มีกำไร"
      },
      "vi": {
        "week": "Tuần này",
        "month": "30 ngày qua",
        "90days": "90 ngày qua",
        "60days": "60 ngày qua",
        "customPeriod": "Khoảng thời gian tùy chỉnh",        "time": "Ngày",
        "strategies": "Chiến lược",
        "moods": "Tâm trạng",
        "assets": "Tài sản",
        "results": "Kết quả",
        "accounts": "Tài khoản",
        "sides": "Phía",
        "apply": "Áp dụng",
        "selectedPeriod": "Khoảng thời gian đã chọn",
        "profit": "Lợi nhuận",
        "loss": "Thua lỗ",
        "normal": "Trung lập",
        "highlight": "Điểm nổi bật của bạn",
        "detailed": "Dữ liệu chi tiết",
        "journal": "Nhật ký giao dịch",
        "trades": "Giao dịch",
        "statics": "Thống kê",
        "calendar": "Lịch",
        "all": "Tất cả",
        "closefilters": "Đóng bộ lọc",
        "openfilters": "Mở bộ lọc",
        "addBrokerAccount": "Thêm tài khoản môi giới",
        "reset": "Đặt lại",
        "netProfit": "Lợi nhuận ròng",
        "swisetRatio": "Tỷ lệ Swiset",
        "winRate": "Tỷ lệ thắng",
        "profitFactor": "Hệ số lợi nhuận",
        "bestTrade": "Giao dịch tốt nhất",
        "worstTrade": "Giao dịch tệ nhất",
        "averageDuration": "Thời gian trung bình",
        "commissions": "Hoa hồng",
        "riskReward": "Tỷ lệ rủi ro/lợi nhuận",
        "profitable": "Có lợi nhuận"
      },
      "zh": {
        "week": "本周",
        "month": "过去30天",
        "90days": "过去90天",
        "60days": "过去60天",
        "customPeriod": "自定义周期",        "time": "日期",
        "strategies": "策略",
        "moods": "情绪",
        "assets": "资产",
        "results": "结果",
        "accounts": "账户",
        "sides": "方向",
        "apply": "应用",
        "selectedPeriod": "选定周期",
        "profit": "利潤",
        "loss": "亏损",
        "normal": "中性",
        "highlight": "您的亮点",
        "detailed": "详细数据",
        "journal": "交易日志",
        "trades": "交易",
        "statics": "统计",
        "calendar": "日历",
        "all": "全部",
        "closefilters": "关闭筛选器",
        "openfilters": "打开筛选器",
        "addBrokerAccount": "添加经纪账户",
        "reset": "重置",
        "netProfit": "净利潤",
        "swisetRatio": "Swiset 比率",
        "winRate": "胜率",
        "profitFactor": "利潤因子",
        "bestTrade": "最佳交易",
        "worstTrade": "最差交易",
        "averageDuration": "平均持续时间",
        "commissions": "佣金",
        "riskReward": "风险/回报比",
        "profitable": "盈利"
      },
      "ja": {
        "week": "今週",
        "month": "過去30日",
        "90days": "過去90日",
        "60days": "過去60日",
        "customPeriod": "カスタム期間",
        "time": "日付",
        "strategies": "ストラテジー",
        "moods": "気分",
        "assets": "アセット",
        "results": "結果",
        "accounts": "アカウント",
        "sides": "サイド",
        "apply": "適用",
        "selectedPeriod": "選択期間",
        "profit": "利益",
        "loss": "損失",
        "normal": "ニュートラル",
        "highlight": "あなたのハイライト",
        "detailed": "詳細データ",
        "journal": "トレーディングジャーナル",
        "trades": "トレード",
        "statics": "統計",
        "calendar": "カレンダー",
        "all": "すべて",
        "closefilters": "フィルターを閉じる",
        "openfilters": "フィルターを開く",
        "addBrokerAccount": "ブローカーアカウントを追加",
        "reset": "リセット",
        "netProfit": "純利益",
        "swisetRatio": "Swisetレシオ",
        "winRate": "勝率",
        "profitFactor": "利益ファクター",
        "bestTrade": "ベストトレード",
        "worstTrade": "ワーストトレード",
        "averageDuration": "平均期間",
        "commissions": "手数料",
        "riskReward": "リスク/リワード比",
        "profitable": "利益性"
      }

    }
</i18n>
<style lang="scss">
.newJournal-view {
  display: flex;
  flex-direction: column;
  font-family: "Avenir";
  font-weight: 300;
  font-size: 16px;
  padding-top: 20px;

  .datesContainer {
    display: flex;
    flex-direction: column;
    justify-content: center;
    background-color: var(--v-mainWhite-base);
    border-radius: 10px;
    padding: 20px;
    color: var(--v-mainBlack-base) !important;

    .v-text-field {
      background-color: var(--v-baseBackground-base);
      color: var(--v-mainBlack-base) !important;
    }

    .v-date-picker {
      .primary {
        background-color: var(--v-mainBtnBackground-base) !important;
        color: var(--v-mainBlack-base) !important;
      }

      .theme--light.v-picker__body,
      .theme--dark.v-picker__body {
        background-color: var(--v-baseBackground-base) !important;
      }

      background-color: var(--v-baseBackground-base);
      color: var(--v-mainBlack-base) !important;

      .v-icon {
        color: var(--v-mainBlack-base) !important;
      }
    }
  }

  .section-header {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    @media (max-width: 768px) {
      margin-left: 0px;
    }

    .title-2 {
      font-weight: 700;
      font-family: "Avenir", sans-serif;
      margin: 0;
      padding-left: 0;
      padding-right: 0;
      color: var(--v-darkGrey-base);

      @media (max-width: 768px) {
        display: flex;
        justify-content: center;
      }
    }

    .conventions {
      list-style-type: none;
      display: flex;
      justify-content: flex-end;

      @media (max-width: 768px) {
        justify-content: center;
      }

      li {
        font-size: 16px;
        display: flex;
        font-style: normal;
        color: var(--v-mainBlack-base) !important;
        line-height: 1;
        background-color: transparent !important;
        align-items: center;
        margin-left: 50px;

        .icon {
          font-size: 18px;
          color: inherit !important;
          margin-right: 10px;
        }

        &.red {
          color: var(--v-darkRed-base) !important;
        }

        &.green {
          color: var(--v-darkGreen-base) !important;
        }
      }
    }
  }

  @media (max-width: 768px) {
    .section-filters {
      padding: 0;
    }
  }

  .section-filters {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 0 0;
    flex-wrap: wrap;
    top: 48px;
    z-index: 2;
    padding: 15px 0;
    padding-bottom: 0;

    .old-filters {
      display: none;
    }

    .filters {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;

      @media (max-width: 600px) {
        margin-left: 20px;
      }

      @media (max-width: 1318px) {
        .select-mcmp {
          margin-bottom: 6px !important;
        }
      }

      .select-mcmp {
        @media (min-width: 1264px) {
          &.col-lg-1 {
            flex: 0 0 14%;
            max-width: 14%;
          }
        }
      }
    }

    .actions {
      flex-wrap: nowrap;
      display: flex;
      margin-top: 10px;
      flex-direction: row;
      justify-content: flex-end;
    }
  }

  .title-3 {
    font-size: 17px;
    font-family: "Avenir", sans-serif;
    color: var(--v-darkGrey-base);
    margin-bottom: 10px;

    @media (max-width: 768px) {
      margin-left: auto;
      margin-right: auto;
      margin-top: 25px;
    }
  }

  .section-ratios {
    .ratios-container {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;

      @media (min-width: 1264px) {
        .col-lg-2 {
          flex: 0 0 30%;
          max-width: 20%;
        }
      }
    }
  }

  @media (min-width: 600px) {
    .section-ratios {
      margin-top: 0px;
      /* Ajusta este valor según tus necesidades */
    }
  }

  .btn {
    margin-right: 5px;
    text-overflow: ellipsis;
    display: block;
    text-wrap: nowrap;
    overflow: hidden;
  }

  .v-btn {
    margin-left: 10px;

    &:first-of-type {
      .svg-icon {
        margin-right: 20px;
      }
    }

    .icon {
      color: inherit !important;
    }
  }

  @media (min-width: 600px) {
    .carousel-container {
      width: 100vw;
      padding-top: 10px;
      padding-bottom: 30px;
    }

    .mobile {
      display: none !important;
    }
  }

  @media (max-width: 599px) {
    .desktop {
      display: none;
    }
  }

  .centered-button {
    display: block;
    margin-left: auto;
    margin-right: auto;
    margin-top: 20px;
    margin-bottom: 5px;
  }

  .v-window__prev,
  .v-window__next {
    background: transparent;
    padding: 0 0px;
  }

  .v-carousel__controls__item,
  .v-window__prev,
  .v-window__next {
    //opacity: 10% !important;
    display: none;
  }

  @media (min-width: 769px) {
    .mobile-button {
      display: none;
    }
  }

  .ratio-card-mobile {
    width: 85%;
    /* Ajusta este valor según tus necesidades */
    text-align: center;
    margin: auto;
    margin-left: 30px;
  }

  .sticky-section {
    position: sticky;
    background-color: var(--v-mainWhite-base);
    top: 0;
    z-index: 2;
    /* Ajusta el valor según sea necesario */
  }
}
</style>
